import { WorkflowFieldObjectKey } from 'dashboard/models/workflow';
import { JsonSchemaTypes } from 'lib/json-schema';

export const MAXIMUM_DEPTH = 3;

export const GENERIC_TYPE_OPTIONS = Object.values(JsonSchemaTypes).sort();
export const PERSONA_OBJECT_TYPE_OPTIONS = [
  // This list is a subset of all available WorkflowFieldObjectKey
  // They are picked because they are the most used ones.
  // If new use cases requires more type, no reason to not simply add it here.
  WorkflowFieldObjectKey.Inquiry,
  WorkflowFieldObjectKey.Account,
  WorkflowFieldObjectKey.Case,
  WorkflowFieldObjectKey.GraphQuery,
  WorkflowFieldObjectKey.ReportAddressLookup,
  WorkflowFieldObjectKey.ReportAdverseMedia,
  WorkflowFieldObjectKey.ReportEmailAddress,
  WorkflowFieldObjectKey.ReportPhoneNumber,
  WorkflowFieldObjectKey.ReportPoliticallyExposedPerson,
  WorkflowFieldObjectKey.ReportProfile,
  WorkflowFieldObjectKey.ReportScreening,
  WorkflowFieldObjectKey.ReportWatchlist,
  WorkflowFieldObjectKey.ReportCryptoAddressWatchlist,
  WorkflowFieldObjectKey.ReportBusinessAdverseMedia,
  WorkflowFieldObjectKey.ReportBusinessAssociatedPersons,
  WorkflowFieldObjectKey.ReportBusinessClassification,
  WorkflowFieldObjectKey.ReportBusinessIndustryClassification,
  WorkflowFieldObjectKey.ReportBusinessLookup,
  WorkflowFieldObjectKey.ReportBusinessNonprofit,
  WorkflowFieldObjectKey.ReportBusinessOnlinePresence,
  WorkflowFieldObjectKey.ReportBusinessRegistrationsLookup,
  WorkflowFieldObjectKey.ReportBusinessSocialMedia,
  WorkflowFieldObjectKey.ReportBusinessWatchlist,
  WorkflowFieldObjectKey.ReportBusinessWebsite,
  WorkflowFieldObjectKey.VerificationGovernmentId,
  WorkflowFieldObjectKey.VerificationGovernmentIdNfc,
  WorkflowFieldObjectKey.VerificationMobileDriversLicense,
  WorkflowFieldObjectKey.VerificationSelfie,
  WorkflowFieldObjectKey.VerificationEmailAddress,
  WorkflowFieldObjectKey.VerificationPhoneNumber,
  WorkflowFieldObjectKey.VerificationBusinessWebsite,
  WorkflowFieldObjectKey.VerificationDocument,
  WorkflowFieldObjectKey.VerificationDatabase,
  WorkflowFieldObjectKey.VerificationDatabaseAadhaar,
  WorkflowFieldObjectKey.VerificationDatabaseBusiness,
  WorkflowFieldObjectKey.VerificationDatabaseBusinessFootprint,
  WorkflowFieldObjectKey.VerificationDatabaseEcbsv,
  WorkflowFieldObjectKey.VerificationDatabasePhoneCarrier,
  WorkflowFieldObjectKey.VerificationDatabaseStandard,
  WorkflowFieldObjectKey.VerificationDatabaseSerpro,
  WorkflowFieldObjectKey.VerificationDatabaseTin,
  WorkflowFieldObjectKey.VerificationDatabaseVatNumber,
  WorkflowFieldObjectKey.VerificationDigitalIdUkSharecode,
  WorkflowFieldObjectKey.Transaction,
];
export const ALL_TYPE_OPTIONS = [...GENERIC_TYPE_OPTIONS, ...PERSONA_OBJECT_TYPE_OPTIONS];
export const BASIC_TYPE_OPTIONS = [
  JsonSchemaTypes.Boolean,
  JsonSchemaTypes.Number,
  JsonSchemaTypes.String,
];

export enum ErrorType {
  DuplicateName = 'duplicate_name',
  BlankName = 'blank_name',
  InvalidCharacter = 'invalid_character',
  EmptyObject = 'empty_object',
}

export const ERROR_MESSAGES: Record<ErrorType, string> = {
  [ErrorType.DuplicateName]: 'No duplicate names',
  [ErrorType.BlankName]: 'No empty names',
  [ErrorType.InvalidCharacter]: 'No special characters',
  [ErrorType.EmptyObject]: 'Objects can never be empty',
};
